import React from "react";

import useTranslation from "next-translate/useTranslation";

import { DisplayText, Stack } from "@shopify/polaris";

import ButtonLarge from "../../components/ButtonLarge";
import DiscordIcon from "../../icons/Discord";
import TopGG from "../../icons/TopGG";

import {
  DISCORD_EMAIL_APP_DIR_LINK,
  DISCORD_EMAIL_TOP_GG_LINK,
  DISCORD_TG_APP_DIR_LINK,
  DISCORD_TG_TOP_GG_LINK,
} from "../../../../../../utils/constants";
import { DISCORD_TELEGRAM_NAMESPACE } from "../../../../../../utils/i18nNameSpaces";

import styles from "./styles.module.scss";

const Index = ({ namespace }) => {
  const { t } = useTranslation(namespace);

  return (
    <section className={styles["TopGG"]}>
      <div className={styles["subheading"]}>{t("topgg.title")}</div>
      <div className={styles["heading"]}>
        <DisplayText size="extraLarge" element="h3">
          Top<span className={styles["pink"]}>.</span>gg
        </DisplayText>
        <DisplayText size="extraLarge" element="h3">
          <span className={styles["purple"]}>Discord App Directory</span>
        </DisplayText>
      </div>
      <Stack alignment="center" distribution="center">
        <ButtonLarge
          icon={TopGG}
          url={
            namespace === DISCORD_TELEGRAM_NAMESPACE
              ? DISCORD_TG_TOP_GG_LINK
              : DISCORD_EMAIL_TOP_GG_LINK
          }
          external
        >
          Top.gg
        </ButtonLarge>
        <ButtonLarge
          icon={DiscordIcon}
          url={
            namespace === DISCORD_TELEGRAM_NAMESPACE
              ? DISCORD_TG_APP_DIR_LINK
              : DISCORD_EMAIL_APP_DIR_LINK
          }
          external
        >
          Discord App Directory
        </ButtonLarge>
      </Stack>
    </section>
  );
};

export default Index;
